/* Snowhollow bundle widget v3 - native Shopify cart, no app, localized. */
(function () {
  'use strict';
  var root, cfg, state = { tier: 0, addons: {} };
  function t(k, d) { return (cfg.t && cfg.t[k]) || d; }
  function money(c) {
    c = Math.round(c);
    if (cfg.currency) { try { return new Intl.NumberFormat(cfg.locale || 'en-US', { style: 'currency', currency: cfg.currency }).format(c / 100); } catch (e) {} }
    return '$' + (c / 100).toFixed(2);
  }
  function tier() { return cfg.tiers[state.tier]; }
  function total() { var s = tier().price; (cfg.addons || []).forEach(function (a) { if (state.addons[a.id]) s += a.price; }); return s; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
  function addBusinessDays(d, n) { var r = new Date(d.getTime()); while (n > 0) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) n--; } return r; }
  function fmt(d, tz) { var o = { month: 'short', day: 'numeric' }; if (tz) o.timeZone = tz; return d.toLocaleDateString(cfg.locale || 'en-US', o); }
  function urgencyHTML() {
    var h = '', now = new Date();
    if (cfg.deliveryMin && cfg.deliveryMax) {
      h += '<div class="bbdl__eta"><span class="bbdl__eta-ic">🚚</span><span>' + esc(t('eta', 'Order today, arrives')) + ' <b>' + fmt(addBusinessDays(now, cfg.deliveryMin)) + ' – ' + fmt(addBusinessDays(now, cfg.deliveryMax)) + '</b>' + (cfg.shipNote ? ' · ' + esc(cfg.shipNote) : '') + '</span></div>';
    }
    if (cfg.cutoff && new Date(cfg.cutoff) > now) {
      h += '<div class="bbdl__cut"><span class="bbdl__eta-ic">🎄</span><span>' + esc(t('cut', 'Christmas delivery: order by')) + ' <b>' + fmt(new Date(cfg.cutoff), 'America/New_York') + '</b> <span class="bbdl__cd" data-cd></span></span></div>';
    }
    return h;
  }
  function tickCountdown() {
    var el = root.querySelector('[data-cd]'); if (!el || !cfg.cutoff) return;
    var ms = new Date(cfg.cutoff) - new Date(); if (ms <= 0) { el.textContent = ''; return; }
    var d = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5) % 24, m = Math.floor(ms / 6e4) % 60, s = Math.floor(ms / 1e3) % 60;
    el.textContent = '· ' + d + t('d', 'd') + ' ' + String(h).padStart(2, '0') + 'h ' + String(m).padStart(2, '0') + 'm ' + String(s).padStart(2, '0') + 's ' + t('left', 'left');
  }
  function render() {
    var h = '';
    if (cfg.label) h += '<p class="bbdl__label">' + esc(cfg.label) + '</p>';
    h += '<div class="bbdl__tiers">';
    cfg.tiers.forEach(function (tr, i) {
      var on = i === state.tier, per = tr.price / tr.qty, save = tr.compareAt && tr.compareAt > tr.price ? tr.compareAt - tr.price : 0;
      h += '<label class="bbdl__tier' + (on ? ' is-on' : '') + '" data-tier="' + i + '">';
      if (tr.badge) h += '<span class="bbdl__badge">' + esc(tr.badge) + '</span>';
      h += '<input type="radio" class="bbdl__radio" name="bbdl-tier" value="' + i + '"' + (on ? ' checked' : '') + '>';
      h += '<span class="bbdl__ht"><span class="bbdl__title">' + esc(tr.title) + '</span>';
      if (tr.subtitle) h += '<span class="bbdl__sub">' + esc(tr.subtitle) + '</span>';
      h += '<span class="bbdl__per">' + money(per) + ' ' + esc(t('perSet', 'per set')) + (save ? ' · <b>' + esc(t('save', 'you save')) + ' ' + money(save) + '</b>' : '') + '</span></span>';
      h += '<span class="bbdl__pr"><span class="bbdl__price">' + money(tr.price) + '</span>';
      if (save) h += '<span class="bbdl__was">' + money(tr.compareAt) + '</span>';
      h += '</span></label>';
    });
    h += '</div>';
    if (cfg.addons && cfg.addons.length) {
      h += '<p class="bbdl__label bbdl__label--add">' + esc(cfg.addonsLabel || 'Add to your order') + '</p><div class="bbdl__addons">';
      cfg.addons.forEach(function (a) {
        h += '<label class="bbdl__addon' + (state.addons[a.id] ? ' is-on' : '') + '"><input type="checkbox" class="bbdl__cb" data-addon="' + a.id + '"' + (state.addons[a.id] ? ' checked' : '') + '>';
        if (a.image) h += '<img class="bbdl__thumb" src="' + esc(a.image) + '" alt="" loading="lazy" width="44" height="44">';
        h += '<span class="bbdl__ai"><span class="bbdl__an">' + esc(a.title) + '</span>' + (a.desc ? '<span class="bbdl__ad">' + esc(a.desc) + '</span>' : '') + '</span><span class="bbdl__ap">+' + money(a.price) + '</span></label>';
      });
      h += '</div>';
    }
    h += '<div class="bbdl__total"><span>' + esc(cfg.totalLabel || 'Total') + '</span><b data-total></b></div>';
    h += '<button type="button" class="bbdl__cta">' + esc(cfg.ctaLabel || 'Add to cart') + '</button>';
    h += '<p class="bbdl__err">' + esc(cfg.errorText || 'Something went wrong. Please try again.') + '</p>';
    h += urgencyHTML();
    root.innerHTML = h; paint(); tickCountdown();
  }
  function paint() { var el = root.querySelector('[data-total]'); if (el) el.textContent = money(total()); }
  function onChange(e) {
    var el = e.target;
    if (el.name === 'bbdl-tier') { state.tier = parseInt(el.value, 10); render(); return; }
    if (el.hasAttribute('data-addon')) { state.addons[el.getAttribute('data-addon')] = el.checked; var l = el.closest('.bbdl__addon'); if (l) l.classList.toggle('is-on', el.checked); paint(); }
  }
  function drawer() { var d = document.querySelector('cart-drawer'); return d && typeof d.renderContents === 'function' && typeof d.getSectionsToRender === 'function' ? d : null; }
  function addToCart() {
    var btn = root.querySelector('.bbdl__cta'); root.classList.remove('has-error'); btn.disabled = true;
    var items = [{ id: Number(cfg.variants[0].id), quantity: tier().qty }];
    (cfg.addons || []).forEach(function (a) { if (state.addons[a.id]) items.push({ id: Number(a.id), quantity: 1 }); });
    var d = cfg.afterAdd === 'drawer' ? drawer() : null, body = { items: items };
    if (d) { try { body.sections = d.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = window.location.pathname; } catch (e) { d = null; } }
    fetch(cfg.routes.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status && res.status >= 400) throw new Error('add failed');
        btn.disabled = false;
        if (d && res && res.sections) { try { d.renderContents(res); return; } catch (e) {} }
        window.location.href = cfg.afterAdd === 'checkout' ? cfg.routes.checkout : cfg.routes.cart;
      })
      .catch(function () { btn.disabled = false; root.classList.add('has-error'); });
  }
  function boot() {
    root = document.getElementById('bundle-builder'); var node = document.getElementById('bundle-builder-config');
    if (!root || !node) return;
    try { cfg = JSON.parse(node.textContent); } catch (e) { return; }
    if (!cfg.tiers || !cfg.tiers.length || !cfg.variants || !cfg.variants.length) return;
    state.tier = Math.max(0, Math.min(cfg.tiers.length - 1, cfg.defaultTier || 0));
    root.classList.add('bbdl'); render();
    root.addEventListener('change', onChange);
    root.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.bbdl__cta')) addToCart(); });
    setInterval(tickCountdown, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
